import React, {useState, useEffect} from 'react';
import Pagination from 'react-js-pagination';
import {useSelector} from 'react-redux';
import {NavLink, useHistory, useLocation} from 'react-router-dom';
import Table from 'react-bootstrap/Table';
import {toast} from 'react-toastify';
import {useMutation, useQuery} from 'react-query';
import {Image} from 'react-bootstrap';
import {AsyncPaginate} from 'react-select-async-paginate';
import {
    EXERCISE_API,
    BaseGatewayImage,
    DISEASE_API,
    ACCOUNT_API
} from '@app/utils/apiUrl.js';
import {DeleteSingle, Get} from '@app/utils/httpProvider';
import {
    createUrlWithParam,
    formatDateTimeCrawler,
    formatDateTimeMoment,
    formatDateTimeWithoutHour,
    formatDateTimeWithoutHourMoment,
    getInfomationAccountFromToken,
    isValidUrl
} from '../../utils/helper';
import {URI_INTERNAL} from '../../utils/pathLocations';
import {
    objectShowNumber,
    messageToast,
    objectDeviceStatus,
    deviceStatus,
    styleSelectDefault,
    role,
    objectTrangThaiDeNghi,
    trangThaiDeNghiValue,
    sortByValue
} from '../../utils/define';
import {ConfirmModal} from '../../modules/modal/ConfirmModal';
import {BrowserView, MobileView} from 'react-device-detect';
import Select from 'react-select';
import {Button} from '@components';

const SelectDoctor = () => {
    const history = useHistory();
    const location = useLocation();
    const valueSearch = useSelector((state) => state.search.valueSearch);

    const [page, setPage] = useState(1);
    const [pageSize, setPageSize] = useState(10000);
    const [search, setSearch] = useState('');

    const [openConfirmDeleteModal, setOpenConfirmDeleteModal] = useState(false);
    const [idWantDelete, setIdWantDelete] = useState('');
    const [confirmDelMessage, setConfirmDelMessage] = useState('');
    const [diseaseId, setDiseaseId] = useState('');

    const [selectedDoctorId, setSelectedDoctorId] = useState(null);

    // let accountRoleAdmin = false;
    // const inforAccount = getInfomationAccountFromToken();

    // if (inforAccount && inforAccount.role) {
    //     const userRole = inforAccount.role.split(', ');
    //     accountRoleAdmin =
    //         userRole.includes(role.Admin) || userRole.includes(role.Doctor);
    // }

    const deleteFunc = useMutation((value) =>
        DeleteSingle(EXERCISE_API.DELETE_ITEM, value, null)
    );

    const paramUrl = new URLSearchParams(location.search.substring(1));
    if (
        paramUrl.get('page') != null &&
        parseInt(paramUrl.get('page'), 10) !== page
    ) {
        const pageResult = parseInt(paramUrl.get('page'), 10);
        setPage(pageResult);
    }
    if (
        paramUrl.get('size') != null &&
        parseInt(paramUrl.get('size'), 10) !== pageSize
    ) {
        const sizeResult = parseInt(paramUrl.get('size'), 10);
        setPageSize(sizeResult);
    }
    if (paramUrl.get('search') != null && paramUrl.get('search') !== search) {
        setSearch(paramUrl.get('search'));
    }

    const exerciseId = paramUrl.get('baitapId');

    // const [isSortedNameAlphabet, setIsSortedNameAlphabet] = useState(false);

    const {isLoading, isError, error, data, refetch} = useQuery(
        ['doctorData', valueSearch, page, pageSize],
        () => {
            let model = {
                Keyword: valueSearch ? valueSearch : '',
                PageIndex: page,
                PageSize: pageSize,
                Role: role.Doctor
            };

            return Get(ACCOUNT_API.GET_PAGING_ACCOUNT, null, model);
        }
    );

    useEffect(() => {
        refetch();
    }, [pageSize, page, diseaseId]);

    const replaceHistory = async (Page, Size, Search) => {
        history.replace(
            createUrlWithParam(URI_INTERNAL.EXERCISE_PATH, {
                page: Page,
                size: Size,
                search: Search
            })
        );
    };

    React.useEffect(() => {
        if (valueSearch != null && valueSearch !== search) {
            replaceHistory(1, pageSize, valueSearch);
        }
    }, [valueSearch]);

    const changePage = (number) => {
        setPage(number);
        replaceHistory(number, pageSize, search);
    };

    const onChangeShowNumber = (e) => {
        setPageSize(e.target.value);
        replaceHistory(page, e.target.value, search);
    };

    const loadOptions = async (search, loadedOptions, {page}) => {
        const pageSize = 10;
        const res = await Get(DISEASE_API.GET_PAGING, null, {
            PageIndex: page,
            PageSize: pageSize,
            Keyword: search // pass the input text to filter server-side
        });

        const data = res.data || [];
        const options = data.map((x) => ({
            label: `${x.name}`,
            value: x.id
        }));

        // assume your API returns total count or a flag for more pages
        const hasMore = data.length === pageSize;
        return {
            options,
            hasMore,
            additional: {page: page + 1}
        };
    };

    return (
        <div className="container-fluid">
            <div id="doctor-tab-content" className="tab-content">
                <div className="row">
                    <div className="col-md-12">
                        <div className="card card-primary card-outline">
                            <div className="card-header">
                                <h3 className="card-title">Chọn bác sĩ</h3>
                            </div>
                            {exerciseId ? (
                                <div className="card-body">
                                    <p>
                                        Chọn bác sĩ sẽ theo dõi tiến độ của bạn:
                                    </p>
                                    <div id="doctors-list" className="row">
                                        {data != null &&
                                        data.data != null &&
                                        data.data != null &&
                                        data.data !== undefined &&
                                        data.data.length > 0 ? (
                                            <>
                                                {data.data.map(
                                                    (item, index) => (
                                                        <div className="col-md-4 mb-4">
                                                            <div
                                                                className={`card doctor-card${
                                                                    selectedDoctorId ===
                                                                    item.id
                                                                        ? ' selected'
                                                                        : ''
                                                                }`}
                                                                onClick={() =>
                                                                    setSelectedDoctorId(
                                                                        item.id
                                                                    )
                                                                }
                                                            >
                                                                <div className="card-body">
                                                                    {/* <img
                                                                src="https://randomuser.me/api/portraits/women/1.jpg"
                                                                alt="Dr. Sarah Johnson"
                                                                className="img-fluid mb-3"
                                                            /> */}
                                                                    <h5>
                                                                        {
                                                                            item.fullName
                                                                        }
                                                                    </h5>
                                                                    <p className="text-muted">
                                                                        {
                                                                            item.pseudonym
                                                                        }
                                                                    </p>
                                                                    <p className="text-muted">
                                                                        {
                                                                            item.email
                                                                        }
                                                                    </p>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    )
                                                )}{' '}
                                            </>
                                        ) : (
                                            <></>
                                        )}
                                    </div>
                                    <div className="text-center mt-4">
                                        <Button
                                            as={NavLink}
                                            to={createUrlWithParam(
                                                URI_INTERNAL.PATIENTPRACTICE_PATH,
                                                {baitapId: exerciseId, bacsiId: selectedDoctorId}
                                            )}
                                            className="btn btn-primary"
                                            activeClassName="active" // adds .active when route matches
                                        >
                                            <i className="fas fa-check-circle" />{' '}
                                            Tiếp tục với bác sĩ chọn
                                        </Button>
                                    </div>
                                </div>
                            ) : (
                                <></>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default SelectDoctor;
